// extracted by mini-css-extract-plugin
var _1 = "Mka6L";
export { _1 as "link" }
